import { createRouter, createWebHistory } from 'vue-router';
import Start from './views/Start.vue';
import AboutMe from './views/AboutMe.vue';
import Beratung from './views/Beratung.vue';
import Kurse from './views/Kurse.vue';
import Preise from './views/Preise.vue';
import Kontakt from './views/Kontakt.vue';
import Stillberatung from './views/Stillberatung.vue';
import Schlafberatung from './views/Schlafberatung.vue';
import Beikostberatung from './views/Beikostberatung.vue';
import Stillvorbereitung from './views/Stillvorbereitung.vue';
import Schlafworkshop from './views/Schlafworkshop.vue';
import Beikostworkshop from './views/Beikostworkshop.vue';
import Impressum from './views/Impressum.vue';
import Datenschutz from './views/Datenschutz.vue';

const routes = [
    {
        path: '/',
        name: 'start',
        component: Start,
        meta: {
            metaTitle: 'Stillberatung, Schlafen & Beikost in Koblenz & Online',
            metaDescription: 'Bedürfnisorientierte Stillberatung in Koblenz & online. Außerdem: individuelle Schlafberatung, Beikostberatung & Eltern-Kurse – mit Vertrauen statt Druck.',
            pageUrl: 'https://maikes-familienbegleitung.de/',
            metaKeywords: 'Familienbegleitung, bindungsorientiert, Koblenz, Elternberatung, Baby, Stillberatung, Schlafberatung, Beikostberatung, Koblenz, Familienberatung, Elternkurse, Babykurse, Aktuelles, Termine'/*,
            ogImage: 'https://maikes-familienbegleitung.de/images/open-graph-image.jpg' */
        }
    },
    {
        path: '/aboutme',
        name: 'aboutme',
        component: AboutMe,
        meta: {
            metaTitle: 'Über Maike Röhrig – Familienbegleitung in Koblenz & Online',
            metaDescription: 'Ich bin zertifizierte BFB bindungsorientierte Familienbegleiterin® und unterstütze bei Stillen, Schlafen & Beikost.',
            metaKeywords: 'Maike Röhrig, Familienbegleiterin, Stillberatung Koblenz, Schlafberatung, Beikostberatung, Elternberatung',
            pageUrl: 'https://maikes-familienbegleitung.de/aboutme'
        }
    },
    {
        path: '/beratung',
        name: 'beratung',
        component: Beratung,
        meta: {
            metaTitle: 'Elternberatung zu Stillen, Schlaf & Beikost – Koblenz & Online',
            metaDescription: 'Bindungsorientierte Elternberatung in Koblenz & online: Stillberatung, Schlafberatung und Beikostberatung.',
            metaKeywords: 'Elternberatung, Stillberatung Koblenz, Schlafberatung, Beikostberatung, Baby, Kleinkind, Familienbegleitung',
            pageUrl: 'https://maikes-familienbegleitung.de/beratung'
        }
    },
    {
        path: '/kurse',
        name: 'kurse',
        component: Kurse,
        meta: {
            metaTitle: 'Elternkurse in Koblenz & Online – Stillen, Schlaf & Beikost',
            metaDescription: 'Kurse für werdende & frischgebackene Eltern: Stillvorbereitung, Schlafworkshops & Beikostkurse in Koblenz',
            metaKeywords: 'Elternkurse, Stillvorbereitung, Schlafworkshop, Beikostkurs, Babyernährung, Elternwissen, Koblenz, online',
            pageUrl: 'https://maikes-familienbegleitung.de/kurse'
        }
    },
    {
        path: '/preise',
        name: 'preise',
        component: Preise,
        meta: {
            metaTitle: 'Preise & Ablauf – Familienberatung & Elternkurse in Koblenz',
            metaDescription: 'Infos zu Kosten & Ablauf deiner Stillberatung, Schlafberatung, Beikostberatung oder Kursanmeldung.',
            metaKeywords: 'Preise, Beratungskosten, Kursgebühren, Stillberatung Koblenz, Familienberatung, Elternkurse',
            pageUrl: 'https://maikes-familienbegleitung.de/preise'
        }
    },
    {
        path: '/kontakt',
        name: 'kontakt',
        component: Kontakt,
        meta: {
            metaTitle: 'Kontakt – Maikes Familienbegleitung in Koblenz & Online',
            metaDescription: 'Ich freue mich auf deine Nachricht – für Fragen zur Stillberatung, Schlafberatung, Beikost oder Kursen.',
            metaKeywords: 'Kontakt, Beratung anfragen, Kursanmeldung, Stillberatung Koblenz, Elternberatung, Maike Röhrig',
            pageUrl: 'https://maikes-familienbegleitung.de/kontakt'
        }
    },
    {
        path: '/stillberatung',
        name: 'stillberatung',
        component: Stillberatung,
        meta: {
            metaTitle: 'Bedürfnisorientierte Stillberatung in Koblenz & Online',
            metaDescription: 'Professionelle Stillberatung bei Stillstart, Schmerzen, Milchstau, Abstillen & mehr – in Koblenz oder digital.',
            metaKeywords: 'Stillberatung Koblenz, Stillen, Stillprobleme, Milchstau, Abstillen, Brustentzündung, Bindung, Stillhilfe',
            pageUrl: 'https://maikes-familienbegleitung.de/stillberatung'
        }
    },
    {
        path: '/schlafberatung',
        name: 'schlafberatung',
        component: Schlafberatung,
        meta: {
            metaTitle: 'Schlafberatung für Babys & Kleinkinder – Koblenz & Online',
            metaDescription: 'Maikes Schlafberatung in Koblenz: kindgerecht & bedürfnisorientiert. Für ruhigere Nächte ohne Schlaftraining!',
            metaKeywords: 'Schlafberatung, Baby Schlaf, Kinderschlaf, Einschlafen, Durchschlafen, Schlafcoaching, Koblenz',
            pageUrl: 'https://maikes-familienbegleitung.de/schlafberatung'
        }
    },
    {
        path: '/beikostberatung',
        name: 'beikostberatung',
        component: Beikostberatung,
        meta: {
            metaTitle: 'Beikostberatung in Koblenz & Online – Sicher starten',
            metaDescription: 'Beratung zum Beikoststart - ob BLW oder Brei – individuell und bindungsorientiert. Sicher starten mit Vertrauen.',
            metaKeywords: 'Beikostberatung, Babyernährung, BLW, Beikoststart, Babybrei, gesunde Beikost, Elternberatung, Koblenz',
            pageUrl: 'https://maikes-familienbegleitung.de/beikostberatung'
        }
    },
    {
        path: '/stillvorbereitung',
        name: 'stillvorbereitung',
        component: Stillvorbereitung,
        meta: {
            metaTitle: 'Stillvorbereitungskurs in Koblenz & Online – Gut vorbereitet',
            metaDescription: 'Stillkurs für werdende Eltern: Alles rund um den Stillstart, um das Vertrauen in deinen Körper zu stärken.',
            metaKeywords: 'Stillvorbereitung, Stillkurs, Stillstart, richtig anlegen, Stillwissen, Milchbildung, Stillen lernen, Stillberatung Koblenz',
            pageUrl: 'https://maikes-familienbegleitung.de/stillvorbereitung'
        }
    },
    {
        path: '/schlafworkshop',
        name: 'schlafworkshop',
        component: Schlafworkshop,
        meta: {
            metaTitle: 'Schlafworkshop in Koblenz & Online – Baby- & Kinderschlaf verstehen',
            metaDescription: 'Praxisnaher Workshop für Eltern zu Babyschlaf & Kleinkindschlaf: Schlaf verstehen, statt trainieren.',
            metaKeywords: 'Schlafworkshop, Baby Schlaf, Kinderschlaf, Schlafgewohnheiten, Co-Sleeping, Einschlafen, Elternkurs, Koblenz',
            pageUrl: 'https://maikes-familienbegleitung.de/schlafworkshop'
        }
    },
    {
        path: '/beikostworkshop',
        name: 'beikostworkshop',
        component: Beikostworkshop,
        meta: {
            metaTitle: 'Beikostworkshop in Koblenz & Online – Sicher starten',
            metaDescription: 'Alles zur Beikost in einem Workshop: BLW, Babybrei, Sicherheit – mit Vertrauen statt Druck.',
            metaKeywords: 'Beikostworkshop, Beikoststart, BLW, Baby Led Weaning, Babybrei, Ernährung, Elternkurs, Koblenz',
            pageUrl: 'https://maikes-familienbegleitung.de/beikostworkshop'
        }
    },
    {
        path: '/impressum',
        name: 'impressum',
        component: Impressum,
        meta: {
            metaTitle: 'Impressum - Maikes Familienbegleitung',
            metaDescription: 'Impressum - Maikes Familienbegleitung',
            pageUrl: 'https://maikes-familienbegleitung.de/impressum',
            metaKeywords: 'Impressum, rechtliche Informationen, Anbieterkennzeichnung'
        }
    },
    {
        path: '/datenschutz',
        name: 'datenschutz',
        component: Datenschutz,
        meta: {
            metaTitle: 'Datenschutz - Maikes Familienbegleitung',
            metaDescription: 'Datenschutz - Maikes Familienbegleitung',
            pageUrl: 'https://maikes-familienbegleitung.de/datenschutz',
            metaKeywords: 'Datenschutz, DSGVO, Datenschutzrichtlinien, Datenverarbeitung'
        }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
        return savedPosition; // Falls die Position gespeichert ist (z.B. bei "Zurück" in der Historie)
        } else {
        return { top: 0 }; // Scrollt immer zum Seitenanfang
        }
    }
});

router.afterEach((to) => {
    document.title = to.meta.metaTitle || 'Maikes Familienbegleitung';

    const descriptionTag = document.querySelector("meta[name='description']");
    if (descriptionTag) {
        descriptionTag.setAttribute("content", to.meta.metaDescription || '');
    }

    const keywordsTag = document.querySelector("meta[name='keywords']");
    if (keywordsTag) {
        keywordsTag.setAttribute("content", to.meta.metaKeywords || '');
    } else {
        const newKeywordsTag = document.createElement("meta");
        newKeywordsTag.setAttribute("name", "keywords");
        newKeywordsTag.setAttribute("content", to.meta.metaKeywords || '');
        document.head.appendChild(newKeywordsTag);
    }

    const ogTitle = document.querySelector("meta[property='og:title']");
    if (ogTitle) {
        ogTitle.setAttribute("content", to.meta.metaTitle || '');
    }

    const ogDescription = document.querySelector("meta[property='og:description']");
    if (ogDescription) {
        ogDescription.setAttribute("content", to.meta.metaDescription || '');
    }

    const ogUrl = document.querySelector("meta[property='og:url']");
    if (ogUrl) {
        ogUrl.setAttribute("content", to.meta.pageUrl || '');
    }

    const ogImage = document.querySelector("meta[property='og:image']");
    if (ogImage) {
        ogImage.setAttribute("content", to.meta.ogImage || '');
    }
});

export default router;
